import React from 'react'
import Profilebar from './Profilebar'
import Profileimage from './Profileimage'
import SocialLinks from './SocialLinks'
import WebsiteLink from './WebsiteLink'
import AboutBox from './AboutBox'
import ProposalBox from './ProposalBox'
import PoliticalInfo from './PoliticalInfo'
import ProfileName from './ProfileName'
import HighlightInfo from './HighlightInfo'
import SocialShare from './SocialShare'
import EducationInfo from './EducationInfo'
import BasicInfo from './BasicInfo'
import OtherCandidates from './OtherCandidates'
import MatchConstituyenteBox from './MatchConstituyenteBox'
import ElegidoBox from './ElegidoBox'
import OtherLists from './OtherLists'
import CelebracionConfetti from './CelebracionConfetti'

const FichaConstituyente = ({ data, path, profilepic }) => {
  const {
    nombre,
    nombrenomina,
    distrito,
    lista,
    militanciamilitantedepartidooindependiente,
    partidopoliticosicorresponde,
    movimientoagrupacion,

    sitioweb,
    twitter,
    twitterImage,
    twitterBanner,
    facebook,
    instagram,

    brevebiografia,
    profesionuoficio,
    ocupacion,
    niveleducacional,
    detalleeducacional,

    edad,
    sexo,
    escanoreservadosino,

    pertenecealacomunidadlgtbiq,
    perteneceaunpueblooriginario,
    pueblooriginariosicorresponde,
    esunapersonaensituaciondediscapacidad,

    letralista,
    numerocandidato,
    numerolista,

    fecharespuestacuestionario,
    pdf,

    paridad,
    reservaescanoreservado,
    elegido,
    cargoenlaconvencion
  } = data

  const shouldRenderHighlight =
    pertenecealacomunidadlgtbiq ||
    perteneceaunpueblooriginario ||
    esunapersonaensituaciondediscapacidad

  const shouldRenderEducation =
    profesionuoficio || niveleducacional || ocupacion


  return (
    <>
      {elegido === 'Electo' && <CelebracionConfetti />}
      <div className="text-left">
        <header className="p-3 bg-white rounded-default sm:p-8">
          <div className="-mx-3 -mt-3 overflow-hidden sm:-mt-8 sm:-mx-8 rounded-t-default ">
            <Profilebar nombre={nombre} twitterBanner={twitterBanner} />
          </div>
          <div className="relative grid-cols-6 gap-3 sm:grid sm:gap-8 mainside">
            <div className="w-32 -mt-8 sm:col-span-1 sm:w-full">
              <Profileimage
                nombre={nombrenomina}
                twitterImage={twitterImage}
                driveImage={profilepic}
              />
            </div>
            <div className="sm:col-span-3">
              <ProfileName
                nombre={nombre}
                nombrenomina={nombrenomina}
                distrito={distrito}
                escanoreservadosino={escanoreservadosino}
                pueblooriginariosicorresponde={pueblooriginariosicorresponde}
                letralista={letralista}
                numerocandidato={numerocandidato}
                numerolista={numerolista}
                sexo={sexo}
                elegido={elegido}
              />
              <PoliticalInfo
                partidopoliticosicorresponde={partidopoliticosicorresponde}
                militanciamilitantedepartidooindependiente={
                  militanciamilitantedepartidooindependiente
                }
                partidopoliticosicorresponde={partidopoliticosicorresponde}
                lista={lista}
                movimientoagrupacion={movimientoagrupacion}
                escanoreservadosino={escanoreservadosino}
                pueblooriginariosicorresponde={pueblooriginariosicorresponde}
              />
              <BasicInfo edad={edad} sexo={sexo} />
            </div>
            <div className="col-span-2 p-0 pt-4 text-left sm:px-4">
              <SocialShare
                className="absolute right-0 mb-4 text-right top-3 sm:top-0 sm:mb-8 sm:relative"
                path={path}
                title={`${nombre} - Distrito ${distrito} - ${
                  lista ? `${lista}` : 'Independiente'
                }`}
              />
              {
                cargoenlaconvencion && (
                  <h2 className="text-center">{cargoenlaconvencion}</h2>
                )
              }
              <ElegidoBox
                nombre={nombre}
                sexo={sexo}
                elegido={elegido}
                paridad={paridad}
                reservaescanoreservado={reservaescanoreservado}
              />
              <MatchConstituyenteBox
                fecharespuestacuestionario={fecharespuestacuestionario}
                nombre={nombrenomina}
              />
              <h4 className="block font-sans text-sm uppercase ">Links:</h4>
              <WebsiteLink website={sitioweb} />
              <SocialLinks
                facebook={facebook}
                twitter={twitter}
                instagram={instagram}
              />
            </div>
          </div>
        </header>

        <div className="grid-cols-3 gap-4 sm:grid">
          <div className="col-span-2">
            {brevebiografia && (
              <AboutBox about={brevebiografia} nombre={nombre} />
            )}
            {pdf && <ProposalBox pdf={pdf} nombre={nombre} />}
          </div>

          <div className="aside">
            {shouldRenderEducation && shouldRenderEducation !== 'No' && (
              <div className="p-4 mt-4 bg-white">
                <h4 className="block mb-2 font-sans text-sm uppercase">
                  {ocupacion ? (
                    <>Educación y Ocupación:</>
                  ) : (
                    <>Educación u Oficio:</>
                  )}
                </h4>

                <EducationInfo
                  profesionuoficio={profesionuoficio}
                  niveleducacional={niveleducacional}
                  detalleeducacional={detalleeducacional}
                  ocupacion={ocupacion}
                />
              </div>
            )}

            {shouldRenderHighlight && shouldRenderHighlight !== 'No' && (
              <div className="p-4 mt-4 bg-white">
                <h4 className="block mb-2 font-sans text-sm uppercase">
                  Destacados:
                </h4>

                <HighlightInfo
                  pertenecealacomunidadlgtbiq={pertenecealacomunidadlgtbiq}
                  perteneceaunpueblooriginario={perteneceaunpueblooriginario}
                  pueblooriginariosicorresponde={pueblooriginariosicorresponde}
                  esunapersonaensituaciondediscapacidad={
                    esunapersonaensituaciondediscapacidad
                  }
                />
              </div>
            )}
            <div className="p-4 mt-4 bg-white">
              <h4 className="block mb-2 font-sans text-sm leading-none uppercase">
                Otros constituyentes de <br />
                <strong>{lista}</strong> en el{' '}
                <strong>Distrito {distrito}</strong>:
              </h4>
              <OtherCandidates
                distrito={distrito}
                lista={lista}
                nombre={nombre}
              />
            </div>
            <div className="p-4 mt-4 bg-white">
              <OtherLists distrito={distrito} lista={lista} nombre={nombre} />
            </div>
          </div>
        </div>

        <hr className="mt-4 mb-4" />
      </div>
    </>
  )
}

export default FichaConstituyente
